/**
 * 外设相关参数
 */
export default {
  // 外设
  PPB_SEARCH: 9, // busiType 查询
  PPB_ON: 1, // busiType 开启
  PPB_OFF: 0, // busiType 关闭
  PPT_LV: 1, // peripheralType 滤毒罐
  PPT_PCR: 2 // peripheralType 生物采集器
};
